import React from 'react';
import PropTypes from 'prop-types';

import Select from 'components/Select';

const mapOption = (item) => ({
  label: item.name,
  value: item.id,
});

class MenuItemsDropdown extends React.PureComponent {
  handleChange = ({ value }) => {
    const { items } = this.props.initialData;
    const menuItem = items.find((i) => i.id === value);
    this.props.onChange(menuItem);
  };

  setSelectedItem = () => {
    const { items } = this.props.initialData;
    const { value } = this.props;
    const selectedItem = items.find((item) => item.id === value);

    return selectedItem ? mapOption(selectedItem) : null;
  };

  render() {
    const { items } = this.props.initialData;
    const { excludeIds, disabled } = this.props;
    const selectItems = items.filter(({ id }) => !excludeIds.includes(id));

    return (
      <Select
        options={selectItems.map(mapOption)}
        placeholder="Select item"
        value={this.setSelectedItem()}
        disabled={disabled}
        onChange={this.handleChange}
      />
    );
  }
}

MenuItemsDropdown.propTypes = {
  initialData: PropTypes.shape({
    items: PropTypes.array,
  }).isRequired,
  value: PropTypes.number,
  excludeIds: PropTypes.array,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
};

export default MenuItemsDropdown;
